<app-youtube-player [id]="video_id" [showProgress]="true"></app-youtube-player>
